import React, { FC } from 'react';
import { Chart, CategoryScale, LinearScale, BarElement, Title, Tooltip } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import styles from './StackBarChart.module.scss';

Chart.register(CategoryScale, LinearScale, BarElement, Title, Tooltip);

interface StackBarChartProps {
    chartPayload: Chart.ChartData;
    showDayTimeLegend: boolean;
    chartTitle: any;
    overnightLegendLabel: any;
    daytimeLegendLabel: any;
}

const StackBarChart: FC<StackBarChartProps> = ({ chartPayload, showDayTimeLegend, chartTitle, overnightLegendLabel, daytimeLegendLabel }) => {
    const options: Chart.ChartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                stacked: true,
                grid: {
                    display: false,
                },
            },
            y: {
                display: true, // Set display to true to show y-axis line
                stacked: true,
                ticks: {
                    beginAtZero: true,
                    stepSize: 1,
                },
            },
        },
        plugins: {
            title: {
                display: true,
                text: chartTitle,
                font: {
                    size: 14,
                    weight: 'light',
                },
            },
            tooltip: {
                enabled: false,
            },
        },
        interactivity: {
            mode: 'index',
            intersect: false,
        },
        hover: { mode: null },
    };
    
    return (
        <>
            <div className={styles.container}>
                <div className={styles.canvasContainer}>
                    <Bar options={options} data={chartPayload} />
                </div>

                <div className={styles.legendWrapper}>
                    <div className={styles.legendItem}>
                        <div className={styles.colorBox} data-testid="overnight-color-box" style={{ backgroundColor: '#00095B' }}></div>
                        <span className={styles.legendLabel}>{overnightLegendLabel}</span>
                    </div>
                    {showDayTimeLegend && (
                        <div className={styles.legendItem}>
                            <div
                                className={styles.colorBox}
                                data-testid="daytime-color-box"
                                style={{
                                    backgroundColor: '#1700F4',
                                    opacity: '0.9',
                                    background: 'repeating-linear-gradient( -45deg, #444cf7, #444cf7 2px, #1700F4 2px, #1700F4 10px )',
                                }}
                            ></div>
                            <span className={styles.legendLabel}>{daytimeLegendLabel}</span>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default StackBarChart;
